import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#16301f] text-[#f7f2e7] border-t border-[#16301f]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <div className="flex items-center gap-4">
              <img src="/images/logo.png" alt="Parker Furnished Stays logo" className="w-14 h-14 rounded-full border border-[#f7f2e7]/25" />
              <div>
                <p className="font-display uppercase tracking-[0.2em] text-lg">Parker Furnished Stays</p>
                <p className="text-[10px] uppercase tracking-[0.28em] text-[#f7f2e7]/50 mt-1">
                  Distinctive Residences · Thoughtfully Hosted
                </p>
              </div>
            </div>
            <p className="font-script text-3xl text-[#f7f2e7] mt-6 -rotate-1 inline-block">
              Space to Live. Room to Stay.
            </p>
            <p className="text-xs text-[#f7f2e7]/55 mt-5">
              <a data-testid="footer-email-link" href="mailto:parkerfurnishedstays@gmail.com" className="hover:text-[#f7f2e7] transition-colors duration-300">parkerfurnishedstays@gmail.com</a>
              <span className="mx-2 text-[#f7f2e7]/30">·</span>
              <a data-testid="footer-phone-link" href="tel:+12254315052" className="hover:text-[#f7f2e7] transition-colors duration-300">225-431-5052</a>
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              ["Residences", "#residences"],
              ["Manifesto", "#manifesto"],
              ["Amenities", "#amenities"],
              ["Enquire", "#inquiry"],
            ].map(([label, href]) => (
              <button
                key={href}
                data-testid={`footer-link-${label.toLowerCase()}`}
                onClick={() => scrollToId(href)}
                className="text-xs uppercase tracking-[0.22em] text-[#f7f2e7]/60 hover:text-[#f7f2e7] transition-colors duration-300"
              >
                {label}
              </button>
            ))}
            <a
              data-testid="footer-maintenance-link"
              href="/maintenance"
              className="text-xs uppercase tracking-[0.22em] text-[#f7f2e7]/60 hover:text-[#f7f2e7] transition-colors duration-300"
            >
              Maintenance
            </a>
            <a
              data-testid="footer-review-link"
              href="/review"
              className="text-xs uppercase tracking-[0.22em] text-[#f7f2e7]/60 hover:text-[#f7f2e7] transition-colors duration-300"
            >
              Leave a review
            </a>
          </nav>
        </div>
        <div className="border-t border-[#f7f2e7]/10 mt-12 pt-6 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-[#f7f2e7]/45">© 2026 Parker Furnished Stays. All rights reserved.</p>
          <p className="text-xs text-[#f7f2e7]/45">Baker · Ascension Parish · Louisiana</p>
        </div>
      </div>
    </footer>
  );
}
